<div class="lush-filter" *ngIf="configTitle !== 'Aiema' && configTitle !== 'Cle' && configTitle !== 'PaulCaroline'">
    <div class="filter-top kbook_border">
        <div class="filter-clear"  >
            <h5  class="mt-2 desktop-only" *ngIf="configTitle!=='SpecialWires' && configTitle!=='KatbookStore' && configTitle!=='LinenRaj' && configTitle!=='Babys Pride' && configTitle!=='Accel'">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2 desktop-only" *ngIf="configTitle==='SpecialWires'" style="color: #0195da;">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2 mobile-only" *ngIf="configTitle!=='BombayHardware' && configTitle!=='KatbookStore' && configTitle!=='SpecialWires' && configTitle!=='Babys Pride' && configTitle!=='LushNGreen' && configTitle!=='MAYAN'" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
            aria-controls="collapseFilter">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2 mobile-only" *ngIf="configTitle==='SpecialWires'"  style="color: #0195da;" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
            aria-controls="collapseFilter">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2 mobile-only" *ngIf="configTitle==='KatbookStore'"  style="color: #0195da;" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
            aria-controls="collapseFilter">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2 mobile-only" *ngIf="configTitle==='Babys Pride'"  style="color: #b70a6a;" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
            aria-controls="collapseFilter">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2 mobile-only" *ngIf="configTitle==='LushNGreen'"  style="color: #6a975c;" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
            aria-controls="collapseFilter">Filters<span class="fa fa-filter filter-icon" aria-hidden="true"></span></h5>
            <h5  class="mt-2  cat-posi" *ngIf="configTitle==='BombayHardware'" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true" style="text-transform: capitalize;font-size:18px !important;margin-left: -45%;"
            aria-controls="collapseFilter">Categories<span class="fa fa-angle-down pl-2" style="justify-content: center;display: flex;align-items: center;font-size: 24px !important;" aria-hidden="true"></span></h5>
            <span class="desktop-only" *ngIf="configTitle!=='SpecialWires' && configTitle!=='Accel'  && configTitle!=='KatbookStore' && configTitle!=='Babys Pride' && configTitle!=='LushNGreen' && configTitle!=='BestGifts' && configTitle!=='BombayHardware' && configTitle!=='Karupattiraja'" (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#dc3545">Clear All</span>
            <span class="desktop-only" *ngIf="configTitle==='BestGifts' || configTitle==='BombayHardware' || configTitle==='Karupattiraja'" (click)="clearBest()" style="cursor: pointer;font-size: 14px;color:#dc3545">Clear All</span>
           <span class="desktop-only" *ngIf="configTitle==='SpecialWires' && active && active!==null && active!==undefined && active!==' '" (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#0195da">Clear All</span>
           <span class="desktop-only" *ngIf="configTitle==='Babys Pride' " (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#dc3545">Clear All</span>
           <span class="desktop-only" *ngIf="configTitle==='LushNGreen' " (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#6b6b6b;text-decoration: underline;align-items: center;display: flex;">Clear All</span>
           <span class="desktop-only" *ngIf="configTitle==='KatbookStore' && active && active!==null && active!==undefined && active!==' ' && active!=='dontcheck'" (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#dc3545">Clear All</span>
           
        </div>
    </div>
   
  <div id="collapseFilter" class="mob-filter collapse" [class]="mobileMedia.matches ? '' :'show'" aria-labelledby="headingZero" data-parent="#accordion"> 
    <span class="btn btn-sm mobile-only" (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#dc3545;position: absolute; left: 68%; top: 1%;" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
    aria-controls="collapseFilter" *ngIf="configTitle!=='SpecialWires'">Clear Filters</span>
    <span class="btn btn-sm mobile-only" (click)="clearAll()" style="cursor: pointer;font-size: 14px;color:#dc3545;position: absolute; left: 75%; top: 1%;" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
    aria-controls="collapseFilter" *ngIf="configTitle==='SpecialWires' && active && active!==null && active!==undefined && active!==' ' ">Clear Filters</span>
    <div *ngIf="categoriesList.length>0  && configTitle !== 'Beaubelle' && configTitle !== 'Accel' && configTitle !== 'LushNGreen'" class="layerd-navigation kbook_border ">
        <div class="filter-collections-group">
            <div id="accordion">
                <h5 class="mb-0"  >
                    <a class="sub-heading" *ngIf="configTitle!=='SpecialWires' && configTitle!=='Babys Pride' && configTitle!=='KatbookStore'  && configTitle!=='LinenRaj' && configTitle!=='LushNGreen' && configTitle!=='SriSenbaga'" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne" style="cursor: pointer;">Categories<i
                        class="fa fa-angle-down arrow-size"></i> </a>
                        <a class="sub-heading" *ngIf="configTitle==='SpecialWires'" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne" style="cursor: pointer;color:#0195da !important">Categories<i
                        class="fa fa-angle-down arrow-size" style="color: #0195da"></i> </a>
                        <div style="display: flex;" *ngIf="configTitle==='Babys Pride'">
                        <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne" style="cursor: pointer;">Categories</a>
                        <span class="baby-rotate">
                        <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne" style="height: 10px;" ></i></span>
                        </div>
                        <div style="display: flex;" *ngIf="configTitle==='SriSenbaga'">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="cursor: pointer;">Categories</a>
                            <span class="baby-rotate">
                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="height: 10px;margin-top: 5%;color: #1b52a4" ></i></span>
                            </div>
                        <div  class="mobile-only">
                        <div style="display: flex;margin-top: 5%;" *ngIf="configTitle==='KatbookStore'">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="cursor: pointer;color: #23a6f0!important;">Institution</a>
                            <span class="baby-rotate">
                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="height: 10px;" ></i></span>
                            
                            </div>
                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                <div class="baby_card_body card-body">
                                    <ng-container *ngIf="configTitle=='KatbookStore'">
                                        <div class="sublist-font" style="margin-bottom: 5px;">
                                            <div class="wrapper" style="color: black;">
                                                <li>
                                                    <form action="/action_page.php">
                                                        <div class="form-check" style="line-height: 2.5rem" >
                                                            <input type="checkbox" class="form-check-input" id="checkinst1" name="option1" value="something" checked (click)="appliedAllCFilter($event)">
                <label class="form-check-label" for="check1" style="text-transform: capitalize;">All</label>
                                                          </div>
                                                      <!-- <div class="form-check"  *ngFor="let facet of affiliation; index as i" style="line-height: 2.5rem">
                                                        <input type="checkbox" class="form-check-input" id="check1" name="option1" value="something" >
                                                        <label class="form-check-label"  for="check1" style="color: #616161;text-transform: capitalize;" >{{facet.name}}</label>
                                                      </div> -->
                                                      <ng-container *ngFor="let facet of categoriesList" >
    
                                                        <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
                                    
                                                                <label class="sub-list_kat"
                                                                    style="text-transform: uppercase;" id="facet.name">
                                    
                                                                    <input type="checkbox" style="padding:10px" class="form-check-input" [id]='' name="option1" value="something" (click)="appliedFilterCategories1($event,facet)"/>
                                    
                                                                    &nbsp;{{ facet.name }} <span class="count"></span>
                                                                    <span class="checkmark"></span>
                                                                </label>
                                    
                                                        </div>
                                                    </ng-container>
                                                      
                                                     
                                                    </form>
                                                </li>
                                               
                                            </div>
                                        </div>
                                    </ng-container>
                                </div></div>
                            <div style="display: flex;margin-top: 2%;" *ngIf="configTitle==='KatbookStore' && affiliation.length!=0" >
                                <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
                                aria-controls="collapseTwo" style="cursor: pointer;color: #23a6f0!important;">Affiliation</a>
                                <span class="baby-rotate">
                                <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne" style="height: 10px;" ></i></span>
                                
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion" *ngIf="configTitle==='KatbookStore' && affiliation.length!=0">
                                    <div class="baby_card_body card-body">
                                        <ng-container *ngIf="configTitle=='KatbookStore' ">
                                            <div class="sublist-font" style="margin-bottom: 5px;">
                                                <div class="wrapper" style="color: black;">
                                                    <li>
                                                        <form action="/action_page.php">
                                                            <div class="form-check" style="line-height: 2.5rem" >
                                                                <input type="checkbox" class="form-check-input" id="checkaff1" name="option1" value="something" (click)="appliedAllAffFilter1($event)" checked>
                                                                <label class="form-check-label" value="all" for="checkaff1" style="text-transform: capitalize;">All</label>
                                                              </div>
                                                          <!-- <div class="form-check"  *ngFor="let facet of affiliation; index as i" style="line-height: 2.5rem">
                                                            <input type="checkbox" class="form-check-input" id="check1" name="option1" value="something" >
                                                            <label class="form-check-label"  for="check1" style="color: #616161;text-transform: capitalize;" >{{facet.name}}</label>
                                                          </div> -->
                                                          <ng-container *ngFor="let facet of affiliation" >
                                                    
                                                            <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
                                                
                                                                    <label class="sub-list_kat"
                                                                        style="text-transform: uppercase;" id="facet.name">
                                                
                                                                        <input type="checkbox" style="padding:10px" class="form-check-input" [id]='' name="option1" value="something" (click)="appliedFilterAffiliation($event,facet)"/>
                                                
                                                                        &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                
                                                            </div>
                                                        </ng-container>
                                                          
                                                         
                                                        </form>
                                                    </li>
                                                   
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div></div>
                                <div style="display: flex;margin-top: 2%;" *ngIf="configTitle==='KatbookStore' && filters.length!=0">
                                    <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true"
                                    aria-controls="collapseThreee" style="cursor: pointer;color: #23a6f0!important;">Medium of Instruction</a>
                                    <span class="baby-rotate">
                                    <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                    aria-controls="collapseOne" style="height: 10px;" ></i></span>
                                    
                                    </div>
                                    <div id="collapseThree" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" *ngIf="configTitle==='KatbookStore' && filters.length!=0">
                                        <div class="baby_card_body card-body">
                                            <ng-container *ngIf="configTitle=='KatbookStore'">
                                                <div class="sublist-font" style="margin-bottom: 5px;">
                                                    <div class="wrapper" style="color: black;">
                                                        <li>
                                                            <form action="/action_page.php">
                                                                <div class="form-check" style="line-height: 2.5rem" >
                                                                    <input type="checkbox" class="form-check-input" id="checkmedium1" name="option1" value="something" checked (click)="appliedAllBFilter1($event)">
                                                                    <label class="form-check-label" for="check1" style="text-transform: capitalize;">All</label>
                                                                  </div>
                                                              <!-- <div class="form-check"  *ngFor="let facet of filters; index as i" style="line-height: 2.5rem">
                                                                <input type="checkbox" class="form-check-input" id="facet.name" name="option1" value="something" >
                                                                <label class="form-check-label" [id]="facet.name" for="check1"  style="color: #616161;text-transform: capitalize;" (click)="appliedFilter($event,facet)">{{facet.name}}</label>
                                                              </div> -->
                                                              <ng-container *ngFor="let facet of filters" >
                                                        
                                                                <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
                                                    
                                                                        <label class="sub-list_kat"
                                                                            style="text-transform: uppercase;" id="facet.name">
                                                    
                                                                            <input type="checkbox" style="padding:10px" class="form-check-input" [id]='' name="option1" value="something" (click)="appliedFilterKat1($event,facet)"/>
                                                    
                                                                            &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                    
                                                                </div>
                                                            </ng-container>
                                                              
                                                             
                                                            </form>
                                                        </li>
                                                       
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div></div>
                                    <div  style="display: flex;margin-top: 2%;" *ngIf="configTitle==='KatbookStore'&& standard.length!=0 ">
                                        <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true"
                                        aria-controls="collapseFour" style="cursor: pointer;color: #23a6f0!important;">Standard</a>
                                        <span class="baby-rotate">
                                        <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                        aria-controls="collapseOne" style="height: 10px;" ></i></span>
                                        
                                        </div>
                                        <div id="collapseFour" *ngIf="configTitle==='KatbookStore' && standard.length!=0 " class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                            <div class="baby_card_body card-body">
                                                <ng-container *ngIf="configTitle=='KatbookStore'">
                                                    <div class="sublist-font" style="margin-bottom: 5px;">
                                                        <div class="wrapper" style="color: black;">
                                                            <li>
                                                                <form action="/action_page.php">
                                                                    <div class="form-check" style="line-height: 2.5rem" >
                                                                        <input type="checkbox" class="form-check-input" id="checkstan1" name="option1" value="something" checked (click)="appliedAllStanFilter1($event)">
                                                                        <label class="form-check-label" for="checkstan" style="text-transform: capitalize;">All</label>
                                                                      </div>
                                                                      <ng-container *ngFor="let facet of standard" >
                                                            
                                                                        <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
                                                            
                                                                                <label class="sub-list_kat"
                                                                                    style="text-transform: uppercase;" id="facet.name">
                                                            
                                                                                    <input type="checkbox" style="padding:10px" class="form-check-input" [id]='' name="option1" value="something" (click)="appliedFilterStandard($event,facet)"/>
                                                            
                                                                                    &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                                                                                    <span class="checkmark"></span>
                                                                                </label>
                                                            
                                                                        </div>
                                                                    </ng-container>
                                                                  
                                                                 
                                                                </form>
                                                            </li>
                                                           
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div></div>
                                        <div  style="display: flex;margin-top: 2%;" *ngIf="configTitle==='KatbookStore' && subject.length!=0 ">
                                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true"
                                            aria-controls="collapseFive" style="cursor: pointer;color: #23a6f0!important;">Subject</a>
                                            <span class="baby-rotate">
                                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                            aria-controls="collapseOne" style="height: 10px;" ></i></span>
                                            
                                            </div>
                                            <div id="collapseFive"  *ngIf="configTitle==='KatbookStore' && subject.length!=0 " class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                                                <div class="baby_card_body card-body">
                                                    <ng-container *ngIf="configTitle=='KatbookStore'">
                                                        <div class="sublist-font" style="margin-bottom: 5px;">
                                                            <div class="wrapper" style="color: black;">
                                                                <li>
                                                                    <form action="/action_page.php">
                                                                        <div class="form-check" style="line-height: 2.5rem" >
                                                                            <input type="checkbox" class="form-check-input" id="checksubj1" name="option1" value="something" checked (click)="appliedAllSubjFilter1($event)">
                                                                            <label class="form-check-label" for="checksubj" style="text-transform: capitalize;">All</label>
                                                                          </div>
                                                                          <ng-container *ngFor="let facet of subject" >
                                                                
                                                                            <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
                                                                
                                                                                    <label class="sub-list_kat"
                                                                                        style="text-transform: uppercase;" id="facet.name">
                                                                
                                                                                        <input type="checkbox" style="padding:10px" class="form-check-input" [id]='' name="option1" value="something" (click)="appliedFilterSubject1($event,facet)"/>
                                                                
                                                                                        &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                                                                                        <span class="checkmark"></span>
                                                                                    </label>
                                                                
                                                                            </div>
                                                                        </ng-container>
                                                                      
                                                                     
                                                                    </form>
                                                                </li>
                                                               
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div></div>
                                            <div  style="display: flex;margin-top: 2%;" *ngIf="configTitle==='KatbookStore' && year.length!=0 ">
                                                <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false"
                                                aria-controls="collapseSix" style="cursor: pointer;color: #23a6f0!important;">Year</a>
                                                <span class="baby-rotate">
                                                <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false"
                                                aria-controls="collapseOne" style="height: 10px;" ></i></span>
                                                
                                                </div>
                                                <div id="collapseSix" class="collapse" aria-labelledby="headingOne" data-parent="#accordion"  *ngIf="configTitle=='KatbookStore' && year.length!=0 ">
                                                    <div class="baby_card_body card-body">
                                                        <ng-container *ngIf="configTitle=='KatbookStore'">
                                                            <div class="sublist-font" style="margin-bottom: 5px;">
                                                                <div class="wrapper" style="color: black;">
                                                                    <li>
                                                                        <form action="/action_page.php">
                                                                            <div class="form-check" style="line-height: 2.5rem" >
                                                                                <input type="checkbox" class="form-check-input" id="checkyear1" name="option1" value="something" checked (click)="appliedAllYeaFilter1($event)">
                                                                                <label class="form-check-label" for="checkyear" style="text-transform: capitalize;">All</label>
                                                                              </div>
                                                                              <ng-container *ngFor="let facet of year" >
                                                                    
                                                                                <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
                                                                    
                                                                                        <label class="sub-list_kat"
                                                                                            style="text-transform: uppercase;" id="facet.name">
                                                                    
                                                                                            <input type="checkbox" style="padding:10px" class="form-check-input" [id]='' name="option1" value="something" (click)="appliedFilterYear1($event,facet)"/>
                                                                    
                                                                                            &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                                                                                            <span class="checkmark"></span>
                                                                                        </label>
                                                                    
                                                                                </div>
                                                                            </ng-container>
                                                                          
                                                                         
                                                                        </form>
                                                                    </li>
                                                                   
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div></div>
                                                  
                                                </div>
                            
                        <!-- <div style="display: flex;" *ngIf="configTitle==='LushNGreen'">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="cursor: pointer;">Categories</a>
                            <span class="baby-rotate">
                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="height: 10px;" ></i></span>
                            </div> -->
                        <!-- <i class="fa fa-angle-down arrow-size" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne" style="display: flex;width: 100%;justify-content: end; margin-top: 3%;cursor: pointer;" ></i> </div> -->
                    <!-- <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"> -->
                    <!-- </button> -->
                </h5>
            </div>
            <!-- <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" *ngIf="configTitle=='KatbookStore'">
                <div class="baby_card_body">
            <ng-container *ngIf="configTitle=='KatbookStore'">
                <div class="sublist-font2" *ngFor="let category of categoriesList; index as i"
                    style="margin-bottom: 5px;">
                    <div class="wrapper" style="margin-left: 10px; color: black;">
                        <li><label [id]='category.name' style="color: #616161" [class.active]="active === category.name || categoryName===category.name"
                                class="sub-list_kat" 
                                (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">{{category.name | titlecase |
                                productDetailsPipe: category.name}}</label></li>
                       
                    </div>
                </div>
            </ng-container>
                </div>
            </div> -->
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" *ngIf="configTitle !=='KatbookStore'">
                <div class="baby_card_body card-body">
                    <ng-container *ngIf="configTitle== 'Mahaveer'">
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px;">
                                <li><a [class.active]="active === category.name" class="sub-list font-weight-bolder"
                                        (click)="checkedevt(category.name, category.name)">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}<span *ngIf="category.subcategories"> <i
                                                class="fa fa-angle-down arrow-size"></i> </span></a></li>
    
                                <div *ngIf="category.subcategories" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORIES -->
                                    <div *ngFor="let subcategory of category.subcategories; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name"
                                                    class="sub-list">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                        </div>
                                        <div *ngIf="subcategory.subcategories" class="wrapper">
                                            <!-- SECOND LEVEL SUBCATEGORIES -->
                                            <div class="wrapper">
                                                <div *ngFor="let subcategory2 of subcategory.subcategories; index as k">
                                                    <li
                                                        (click)="checkedevt(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                        <a [class.active]="active === subcategory2.name"
                                                            class="sub-list">{{subcategory2.name | titlecase |
                                                            productDetailsPipe:
                                                            subcategory2.name}}</a>
                                                    </li>
                                                    <!-- THIRD LEVEL SUBCATEGORY -->
                                                    <div *ngIf="subcategory2.subcategories;" class="wrapper">
                                                        <div class="wrapper">
                                                            <div
                                                                *ngFor="let subcategory3 of subcategory2.subcategories; index as l">
                                                                <div class="wrapper">
                                                                    <li
                                                                        (click)="checkedevt(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                        <a [class.active]="active === subcategory3.name"
                                                                            class="sub-list">{{subcategory3.name | titlecase
                                                                            |
                                                                            productDetailsPipe: subcategory3.name}}</a>
                                                                    </li>
                                                                    <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                    <div class="wrapper">
                                                                        <div
                                                                            *ngFor="let subcategory4 of subcategory3.subcategories; index as m">
                                                                            <div class="wrapper">
                                                                                <li><a [class.active]="active === subcategory4.name"
                                                                                        class="sub-list"
                                                                                        (click)="checkedevt(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                        | titlecase | productDetailsPipe:
                                                                                        subcategory4.name}}</a></li>
                                                                                <!-- FIFTH LEVEL SUBCATEGORIES -->
                                                                                <div class="wrapper">
                                                                                    <div
                                                                                        *ngFor="let subcategory5 of subcategory4.subcategories;index as n">
                                                                                        <li><a [class.active]="active === subcategory5.name"
                                                                                                class="sub-list"
                                                                                                (click)="checkedevt(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                | titlecase |
                                                                                                productDetailsPipe:
                                                                                                subcategory5.name}}</a></li>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
    
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="configTitle=='LuckMe' || configTitle=='Murgasen'">
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;">
                                <!-- <li><a [class.active]="active === category.name" class="sub-list font-weight-bolder" (click)="checkedevt(category.name, category.name)">{{category.name | titlecase | productDetailsPipe}}<span *ngIf="category.subcategories"> <i class="fa fa-angle-down arrow-size"></i> </span></a></li> -->
                                <li><a [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list font-weight-bolder"
                                        (click)="checkedevt1(category.name, category.name)">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}<span *ngIf="category.subcategories"> <i
                                                class="fa fa-angle-down arrow-size"></i> </span></a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name"
                                                    class="sub-list">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="configTitle=='Beaubelle'">
                        <!-- <div class="sublist-font" *ngFor="let category of allCategories; index as i"
                            style="margin-bottom: 5px;"> -->
                            <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;">
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list font-weight-bolder"
                                        (click)="checkedevt1(category.name, category.name)">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}1
                                        <span *ngIf="category.subcategories"> <i
                                        class="fa fa-angle-down arrow-size"></i> </span>
                                    </a></li>
                                <div class="wrapper" *ngIf="categoryName===category.name">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                        
                                        <li
                                        (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                        <a [class.active]="active === subcategory.name"
                                            class="sub-list">{{subcategory.name
                                            | titlecase | productDetailsPipe: subcategory.name}}</a>
                                        </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="configTitle=='BombayHardware'">
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i" style="margin-bottom: 5px;">
                            <div class="wrapper" style="color: black;">
                                <li>
                                    <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list font-weight-bolder" (click)="checkedevt1(category.name, category.name)">
                                        {{category.name | titlecase | productDetailsPipe: category.name}}<span *ngIf="category.subcategories"> <i
                                            class="fa fa-angle-down arrow-size"></i> </span>
                                    </a>
                                </li>
                                <div class="wrapper" *ngIf="categoryName===category.name">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a class="sub-list" [class.active]="active === subcategory.name">
                                                    {{subcategory.name | titlecase | productDetailsPipe: subcategory.name}}
                                                </a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name" class="sub-list">
                                                                {{subcategory2.name | titlecase | productDetailsPipe: subcategory2.name}}
                                                            </a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                                <a [class.active]="active === subcategory3.name" class="sub-list">
                                                                                    {{subcategory3.name | titlecase | productDetailsPipe: subcategory3.name}}
                                                                                </a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name" class="wrapper">
                                                                            <div *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li>
                                                                                        <a [class.active]="active === subcategory4.name" class="sub-list"(click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">
                                                                                            {{subcategory4.name | titlecase | productDetailsPipe: subcategory4.name}}
                                                                                        </a>
                                                                                    </li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li>
                                                                                                <a [class.active]="active === subcategory5.name" class="sub-list"(click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">
                                                                                                    {{subcategory5.name | titlecase | productDetailsPipe: subcategory5.name}}
                                                                                                </a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- katbookfilter1 -->
                 



                    <ng-container *ngIf="configTitle=='SpecialWires'">
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i" style="margin-bottom: 5px;width: 110%;">
                            <div class="wrapper" style="color: #0195da;">
                                <li>
                                    <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list font-weight-bolder" (click)="checkedevt1(category.name, category.name)">
                                        {{category.name | productDetailsPipe: category.name}}<span *ngIf="category.subcategories"> <i
                                            class="fa fa-angle-down arrow-size"></i> </span>
                                    </a>
                                </li>
                                <div class="wrapper" *ngIf="categoryName===category.name">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a class="sub-list special-sub-category" [class.active]="active === subcategory.name">
                                                    {{subcategory.name | productDetailsPipe: subcategory.name}}
                                                </a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name" class="sub-list">
                                                                {{subcategory2.name | productDetailsPipe: subcategory2.name}}
                                                            </a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                                <a [class.active]="active === subcategory3.name" class="sub-list">
                                                                                    {{subcategory3.name | productDetailsPipe: subcategory3.name}}
                                                                                </a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name" class="wrapper">
                                                                            <div *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li>
                                                                                        <a [class.active]="active === subcategory4.name" class="sub-list"(click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">
                                                                                            {{subcategory4.name | productDetailsPipe: subcategory4.name}}
                                                                                        </a>
                                                                                    </li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li>
                                                                                                <a [class.active]="active === subcategory5.name" class="sub-list"(click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">
                                                                                                    {{subcategory5.name | productDetailsPipe: subcategory5.name}}
                                                                                                </a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- <ng-container *ngIf="configTitle=='SpecialWires'">
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i" style="margin-bottom: 5px;">
                            <div class="wrapper" style="color: #0195da">
                                <li>
                                    <a [id]='category.name' [class.active]="active === category.name"
                                        class="sub-list3 font-weight-bolder" (click)="checkedevt1(category.name, category.name)">
                                        {{category.name | titlecase | productDetailsPipe: category.name}}
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container> -->
                    <ng-container *ngIf="configTitle=='Babys Pride'">
    
                        <div class="sublist-font2" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;">
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list_baby pro_list_color" 
                                        (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}</a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                    class="sub-list_baby pro_list_color">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list_baby">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list_baby">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list_baby"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list_baby"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="configTitle=='SriSenbaga'">
    
                        <div class="sublist-font2" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;">
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list_baby pro_list_color" 
                                        (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}</a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                    class="sub-list_baby pro_list_color">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list_baby">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list_baby">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list_baby"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list_baby"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <button id="collapseFilter" class="mobile-only filter-button" type="button" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
     aria-controls="collapseFilter">Apply Filter</button>

                    <!-- <ng-container *ngIf="configTitle=='LushNGreen'">
    
                        <div class="sublist-font2" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;">
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list_baby pro_list_color" 
                                        (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}</a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                    class="sub-list_baby pro_list_color">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list_baby">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list_baby">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list_baby"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list_baby"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container> -->
                    <ng-container *ngIf="configTitle=='ShubhCards' || configTitle=='Schift Cosmetics'|| configTitle=='Carience'|| configTitle=='Vimpro'|| configTitle=='Karupattiraja'">
    
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;">
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list font-weight-bolder pro_list_color" 
                                        (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}</a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                    class="sub-list pro_list_color">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container class="mobile-only" *ngIf="configTitle=='Deera'">
                        <!-- <nav class="desktop-only">
                                <ul class="mcd-menu" *ngFor="let category of categoriesList; index as i">
                                    <li>
                                        <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name" (click)="checkedevt1(category.name, category.name)" class="sub-list font-weight-bolder pro_list_color" style="text-transform:uppercase;">
                                            {{category.name | titlecase |
                                                productDetailsPipe: category.name}}
                                        </a>
                                    </li>
                                    <div *ngIf="categoryName===category.name" class="wrapper" style="margin-left: 7%;">
                                        <div *ngFor="let subcategory of subCategory2; index as j">
                                            <div class="wrapper">
                                                <li
                                                    (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                    <a class="sub-list pro_list_color " [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                        class="sub-list pro_list_color">{{subcategory.name
                                                        | titlecase | productDetailsPipe: subcategory.name}}</a>
                                                        <ul *ngIf="active === subcategory.name && subcategory.sub_category">
                                                            <li *ngFor="let data of subcategory.sub_category; index as k">
                                                                <a *ngIf="active === subcategory.name" (mouseenter)="appliedDeeraColor(data.color)"   (mouseleave)="appliedDeeraColor1(data.color)">{{data.color}}</a>
                                                                    <ul *ngIf="active2===data.color">
                                                                    <li *ngFor="let data1 of data.dimension; index as k">
                                                                        <a (click)="appliedDeeraDimension(data1)">{{data1}}</a>
                                                                    </li>
                                                                </ul>
                                                            </li>                                                            
                                                        </ul>
                                                
                                                </li>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>
                                </ul>
                            </nav> -->
                            <nav class="mobile-only">
                                <!-- <ul class="mcd-menu" style="width: 100%!important;" *ngFor="let category of categoriesList; index as i">
                                    <li>
                                        <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name" (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">
                                            {{category.name | titlecase |
                                                productDetailsPipe: category.name}}
                                        </a>
                                    </li>
                                    <div *ngIf="categoryName===category.name" class="wrapper" style="margin-left: 7%;">
                                        <div *ngFor="let subcategory of subCategory2; index as j">
                                            <div class="wrapper">
                                                <li
                                                    (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                    <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                        class="sub-list pro_list_color">{{subcategory.name
                                                        | titlecase | productDetailsPipe: subcategory.name}}</a>
                                                        <ul>
                                                            <li><a>Black</a></li>
                                                            <li>
                                                                <a>Red</a>
                                                                <ul>
                                                                    <li><a>10</a></li>
                                                                    <li>
                                                                        <a>12</a>
                                                                    </li>
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                
                                                </li>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>
                                </ul> -->
                                <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                                style="margin-bottom: 5px;">
                                <div class="wrapper" style="margin-left: 10px; color: black;">
                                    <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                            class="sub-list font-weight-bolder pro_list_color" 
                                            (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase;">{{category.name | titlecase |
                                            productDetailsPipe: category.name}}</a></li>
                                    <div *ngIf="categoryName===category.name" class="wrapper">
                                        <!-- FIRST LEVEL SUBCATEGORY -->
                                        <div *ngFor="let subcategory of subCategory2; index as j">
                                            <div class="wrapper">
                                                <li
                                                    (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                    <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                        class="sub-list pro_list_color">{{subcategory.name
                                                        | titlecase | productDetailsPipe: subcategory.name}}</a>
                                                </li>
                                                <div *ngIf="active===subcategory.name" class="wrapper" style="margin-left: 15px!important;">
                                                    <!-- SECOND LEVEL SUBCATEGORY -->
                                                    <div>
                                                        <div class="wrapper">
                                                            <li *ngFor="let data of subcategory.sub_category; index as k">
                                                                <a *ngIf="active === subcategory.name" (click)="appliedDeeraColor(data.color)" class="sub-list">- {{data.color}}</a>
                                                                <div *ngIf="active===subcategory.name" class="wrapper">
                                                                    <div class="wrapper">
                                                                        <div *ngIf="active2===data.color">
                                                                            <div class="wrapper" style="margin-left: 4%;">
                                                                                <li *ngFor="let data1 of data.dimension; index as k">
                                                                                    <a (click)="appliedDeeraDimension(data1)"
                                                                                        class="sub-list">- {{data1}}</a>
                                                                                </li>
                            
                                                                                </div>
                                                                                </div>
                                                                                </div>
                                                                                </div>
                                                            </li>
                                                
                                                            </div>
                                                            </div>
                                                            </div>
                                                    </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </ng-container>
                    <ng-container *ngIf="configTitle=='Kubendran'">
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;width: 100%;">
                                <!-- <li><a [class.active]="active === category.name" class="sub-list font-weight-bolder" (click)="checkedevt(category.name, category.name)">{{category.name | titlecase | productDetailsPipe}}<span *ngIf="category.subcategories"> <i class="fa fa-angle-down arrow-size"></i> </span></a></li> -->
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list font-weight-bolder" 
                                        (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase"><span style="margin-left: 5px;">{{category.name | titlecase |
                                            productDetailsPipe: category.name}}</span></a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name" [id]='subcategory.name'
                                                    class="sub-list">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name" [id]='subcategory2.name'
                                                                class="sub-list">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="configTitle=='BestGifts'">
                        <div class="sublist1-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black;width: 100%;">
                                <!-- <li><a [class.active]="active === category.name" class="sub-list font-weight-bolder" (click)="checkedevt(category.name, category.name)">{{category.name | titlecase | productDetailsPipe}}<span *ngIf="category.subcategories"> <i class="fa fa-angle-down arrow-size"></i> </span></a></li> -->
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list1 font-weight-bolder" 
                                        (click)="checkedevt1(category.name, category.name)" style="text-transform:uppercase"><span><img style="width: 55px!important;" [src]="category.image"></span><span style="margin-left: 5px;">{{category.name | titlecase |
                                            productDetailsPipe: category.name}}</span></a></li>
                                <div *ngIf="categoryName===category.name" class="wrapper">
                                    <!-- FIRST LEVEL SUBCATEGORY -->
                                    <div *ngFor="let subcategory of subCategory2; index as j">
                                        <div class="wrapper">
                                            <li
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                                <a [class.active]="active === subcategory.name"
                                                    class="sub-list1">{{subcategory.name
                                                    | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                            <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                <!-- SECOND LEVEL SUBCATEGORY -->
                                                <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                    <div class="wrapper">
                                                        <li
                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                            <a [class.active]="active === subcategory2.name"
                                                                class="sub-list1">{{subcategory2.name | titlecase |
                                                                productDetailsPipe: subcategory2.name}}</a>
                                                        </li>
                                                        <!-- THIRD LEVEL SUBCATEGORY -->
                                                        <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                            <div class="wrapper">
                                                                <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                    <div class="wrapper">
                                                                        <li
                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                            <a [class.active]="active === subcategory3.name"
                                                                                class="sub-list1">{{subcategory3.name |
                                                                                titlecase |
                                                                                productDetailsPipe: subcategory3.name}}</a>
                                                                        </li>
                                                                        <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                        <div *ngIf="categoryName3===subcategory3.name"
                                                                            class="wrapper">
                                                                            <div
                                                                                *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                <div class="wrapper">
                                                                                    <li><a [class.active]="active === subcategory4.name"
                                                                                            class="sub-list1"
                                                                                            (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                            | titlecase |
                                                                                            productDetailsPipe:
                                                                                            subcategory4.name}}</a></li>
                                                                                    <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                    <div class="wrapper">
                                                                                        <div
                                                                                            *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                            <li><a [class.active]="active === subcategory5.name"
                                                                                                    class="sub-list1"
                                                                                                    (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                    | titlecase |
                                                                                                    productDetailsPipe:
                                                                                                    subcategory5.name}}</a>
                                                                                            </li>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
    
                                                                    </div>
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
    
    
    
        </div>
    </div>
    <div *ngIf="themes && configTitle === 'ShubhCards'">
        <div *ngIf="themes.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true"
                        aria-controls="collapseThree" style="cursor: pointer;">Themes<i
                                                class="fa fa-angle-down arrow-size"></i>    </a>
                       
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of themes">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterTheme($event,facet)" />
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    
    <div *ngIf="author && configTitle === 'SriSenbaga'">
        <div *ngIf="author.length != 0" class="layerd-navigation" id="authorId">
            <div class="filter-collections-group">
                <div id="accordion" >
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseThirteen" aria-expanded="true"
                        aria-controls="collapseThirteen" style="cursor: pointer;display: flex;">Author
                        <span class="baby-rotate">
                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseThirteen" aria-expanded="true"
                            aria-controls="collapseOne" style="height: 10px;margin-top: 20%;" ></i></span>  </a>
                       
                </div>
                <div id="collapseThirteen" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <div class="sublist-font2" *ngFor="let category of author; index as i"
                            style="margin-bottom: 5px;">
                            <div class="wrapper" style="margin-left: 10px; color: black; overflow: hidden;">
                                <li><a [id]='category.name' [class.active]="activeauthor === category.name"
                                        class="sub-list_baby pro_list_color" 
                                        (click)="appliedFilterAuthor($event, category.name)" style="text-transform:uppercase;">{{category.name}}</a></li>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="filters && configTitle !== 'ShubhCards' && configTitle !== 'Schift Cosmetics' && configTitle !== 'KatbookStore'  && configTitle !== 'Accel' && configTitle !== 'Aiema' && configTitle !== 'Cle' && configTitle !== 'Deera' && configTitle!=='Babys Pride'  && configTitle !== 'SpecialWires' && configTitle !== 'Carience'&& configTitle !== 'Vimpro' && configTitle !== 'BestGifts' && configTitle !== 'Kubendran' && configTitle !== 'BombayHardware'&& configTitle !== 'Karupattiraja' && configTitle!=='LushNGreen' && configTitle!=='SriSenbaga'" >
        <!-- <div *ngIf="filters" > -->

        <div *ngIf="filters.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading "  data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
                        aria-controls="collapseTwo" style="cursor: pointer;">Brands<i
                        class="fa fa-angle-down arrow-size"></i></a>
                       
                </div>
                <div id="collapseTwo" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">

                        <ng-container *ngFor="let facet of filters">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label  class="checkbox-container sub-list font-weight-bolder"
                                        style="color: #e7762d;">
                                         
                                        <input type="checkbox" [id]='facet.name'   (click)="appliedFilter($event,facet)" />
                                         
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark" ></span>
                                    </label>    
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
        <!-- beaubelle filter -->
        <div *ngIf="categoriesList.length>0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <h5 class="mb-0" >
                        <a class="sub-heading" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne" style="cursor: pointer;">Categories<i
                            class="fa fa-angle-down arrow-size"></i> </a>
                        
                    </h5>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                       
                      
                        
                        <ng-container *ngIf="configTitle=='Beaubelle'">
                            
                                <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                                style="margin-bottom: 5px;">
                                <div class="wrapper" style="margin-left: 10px; color: black;">
                                    <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                            class="sub-list font-weight-bolder"
                                            (click)="checkedevt1(category.name, category.name)">{{category.name | titlecase |
                                            productDetailsPipe: category.name}}
                                            <!-- <span *ngIf="category.subcategories"> <i
                                            class="fa fa-angle-down arrow-size"></i> </span> -->
                                        </a></li>
                                    <div class="wrapper" *ngIf="categoryName===category.name">
                                        <!-- FIRST LEVEL SUBCATEGORY -->
                                        <div *ngFor="let subcategory of subCategory2; index as j">
                                            <div class="wrapper">
                                                <!-- <li>
                                                <a [id]='subcategory.name' [class.active]="active === subcategory.name"
                                                (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)"
                                                    class="sub-list">{{subcategory.name
                                                     | productDetailsPipe: subcategory.name}}</a>
                                            </li> -->
                                            <li
                                            (click)="checkedevt1(category.name+' > '+subcategory.name, subcategory.name)">
                                            <a [class.active]="active === subcategory.name"
                                                class="sub-list">{{subcategory.name
                                                | titlecase | productDetailsPipe: subcategory.name}}</a>
                                            </li>
                                                <div *ngIf="categoryName1===subcategory.name" class="wrapper">
                                                    <!-- SECOND LEVEL SUBCATEGORY -->
                                                    <div *ngFor="let subcategory2 of subCategory4; index as k">
                                                        <div class="wrapper">
                                                            <li
                                                                (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name, subcategory2.name)">
                                                                <a [class.active]="active === subcategory2.name"
                                                                    class="sub-list">{{subcategory2.name | titlecase |
                                                                    productDetailsPipe: subcategory2.name}}</a>
                                                            </li>
                                                            <!-- THIRD LEVEL SUBCATEGORY -->
                                                            <div *ngIf="categoryName2===subcategory2.name" class="wrapper">
                                                                <div class="wrapper">
                                                                    <div *ngFor="let subcategory3 of subCategory6; index as l">
                                                                        <div class="wrapper">
                                                                            <li
                                                                                (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name, subcategory3.name)">
                                                                                <a [class.active]="active === subcategory3.name"
                                                                                    class="sub-list">{{subcategory3.name |
                                                                                    titlecase |
                                                                                    productDetailsPipe: subcategory3.name}}</a>
                                                                            </li>
                                                                            <!-- FOURTH LEVEL SUBCATEGORY -->
                                                                            <div *ngIf="categoryName3===subcategory3.name"
                                                                                class="wrapper">
                                                                                <div
                                                                                    *ngFor="let subcategory4 of subCategory8; index as m">
                                                                                    <div class="wrapper">
                                                                                        <li><a [class.active]="active === subcategory4.name"
                                                                                                class="sub-list"
                                                                                                (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name, subcategory4.name)">{{subcategory4.name
                                                                                                | titlecase |
                                                                                                productDetailsPipe:
                                                                                                subcategory4.name}}</a></li>
                                                                                        <!-- FIFTH LEVEL SUBCATEGORY -->
                                                                                        <div class="wrapper">
                                                                                            <div
                                                                                                *ngFor="let subcategory5 of subCategory10;index as n">
                                                                                                <li><a [class.active]="active === subcategory5.name"
                                                                                                        class="sub-list"
                                                                                                        (click)="checkedevt1(category.name+' > '+subcategory.name+' > '+subcategory2.name+' > '+subcategory3.name+' > '+subcategory4.name+' > '+ subcategory5.name, subcategory5.name)">{{subcategory5.name
                                                                                                        | titlecase |
                                                                                                        productDetailsPipe:
                                                                                                        subcategory5.name}}</a>
                                                                                                </li>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
        
                                                                        </div>
        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        
                        
    
                       
                    </div>
                </div>
        
        
        
            </div>
        </div>







<!-- bbfilter -->
    </div>
    <!-- <div *ngIf="size && configTitle === 'BombayHardware' ">
        <div *ngIf="size.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="true"
                        aria-controls="collapseSeven" style="cursor: pointer;">Size<i
                        class="fa fa-angle-down arrow-size"></i></a>
                       
                </div>
                <div id="collapseSeven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of size">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterSize($event,facet)" />
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div> -->
    <!-- <div *ngIf="size && configTitle=='Babys Pride'">
        <div *ngIf="size.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false"
                            aria-controls="collapseSeven" style="cursor: pointer;">Age</a>
                            <span class="baby-rotate">
                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false"
                            aria-controls="collapseSeven" style="height: 10px;" ></i></span>
                            </div>
                       
                </div>
                <div id="collapseSeven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of size">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
                                    <form>
                                        <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:13px!important;font-weight: 500;;color: #bf0a6d;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterSize($event,facet)" />
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
                                    </form>
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div> -->
    <div *ngIf="size && (configTitle === 'Beaubelle' || configTitle === 'BestGifts')">
        <div *ngIf="size.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="true"
                        aria-controls="collapseSeven" style="cursor: pointer;">Size<i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseSeven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of size">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
                                    <form>
                                        <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterSize($event,facet)" />
                                        <!-- <input type="checkbox"  (click)="appliedFilterColor($event,facet)"/> -->
                                        <!-- <input type="checkbox" [id]='facet.name' name="facet.name" (click)="appliedFilterSize($event,facet)" /> -->
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
                                    </form>
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <!-- <div *ngIf="thickness && configTitle === 'BombayHardware'">
        <div *ngIf="size.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true"
                        aria-controls="collapseFive" style="cursor: pointer;">Thickness<i
                        class="fa fa-angle-down arrow-size"></i></a>
                       
                </div>
                <div id="collapseFive" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of thickness">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterThickness($event,facet)"  />
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div> -->
    <div *ngIf="features && configTitle === 'ShubhCards'">
        <div *ngIf="features.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true"
                        aria-controls="collapseFive" style="cursor: pointer;">Features<i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseFive" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of features">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterFeature($event,facet)" />
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="age && configTitle === 'Babys Pride'">
        <div *ngIf="age.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseTwelve" aria-expanded="myboolean"
                            aria-controls="collapseTwelve" style="cursor: pointer;">Age</a>
                            <span class="baby-rotate">
                            <i class="fa fa-angle-down arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseTwelve" aria-expanded="myboolean"
                            aria-controls="collapseTwelve" style="height: 10px;" ></i></span>
                            </div>
                </div>
                <div id="collapseTwelve" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" #collapseTwelve>
                    <div class="card-body">
                        <ng-container *ngFor="let facet of age" >
    
                            <div class="collection-collapse-block"  *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:13px !important;font-weight: 500;color: #bf0a6d;">
    
                                        <input type="checkbox" [(ngModel)]="clearPlant" [id]='facet.name' (click)="appliedFilterAge($event,facet) "/>
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="prices && configTitle === 'Babys Pride'">
        
        <div *ngIf="prices.length != 0" class="layerd-navigation">
            
            <div class="filter-collections-group">
                <div id="accordion">
                    <!-- <a class="sub-heading" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true"
                        aria-controls="collapseSix" style="cursor: pointer;">Prices <i
                        class="fa fa-angle-down arrow-size"></i> </a> -->
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix" style="cursor: pointer;">PRICES</a>
                            <span class="baby-rotate">
                                <i class="fa fa-angle-down arrow-size baby_arrow collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix" style="height: 10px;"></i>
                            </span>
                        </div>
                        
                </div>
                
                    <!-- <ng5-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"></ng5-slider> -->
                    <div id="collapseSix" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" #collapseSix>
                        <div class="card-body">
                    <!-- <ng5-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"></ng5-slider> -->
                   
                    <div class="slider-track">
                        <!-- <style>
                            input[type="range"]{
                                -webkit-appearance: none;
                                -moz-appearance:none;
                                appearance: none;
                                width: 100%;
                                outline: none;
                                position: absolute;
                                margin: auto;
                                top: 0;
                                bottom: 0;
                                background-color: transparent;
                                pointer-events: none;
                            }
                            @media (min-width: 640px) {
                            .slider-track{
                            width: 16%;
    height: 5px;
    background-color: #d5d5d5;
    position: absolute;
    margin: auto;
    border-radius: 5px;
    margin-top: 15px;
                            }
                        }
                        @media (max-width: 640px) {
                            .slider-track{
                            width: 60%;
    height: 5px;
    background-color: #d5d5d5;
    position: absolute;
    margin: auto;
    border-radius: 5px;
    margin-top: 15px;
                            }
                        }
                            input[type="range"]::-webkit-slider-runnable-track{
                                -webkit-appearance:none;
                                height: 5px;
                            }
                            input[type="range"]::-moz-range-track{
                                -moz-appearance:none;
                                height: 5px;
                            }
    input[type="range"]::-ms-track{
        appearance: none;
        height: 5px;
    }
    input[type="range"]::-webkit-slider-thumb{
        -webkit-appearance:none;
        height: 20px;
        width: 20px;
        background-color: #9b0858;
        cursor: pointer;
        border-radius: 10px;
        pointer-events: auto;
        margin-top: -9px;
        pointer-events: auto;
    }
    input[type="range"]::-moz-range-thumb{
        -webkit-appearance: none;
        height: 20px;
        width: 20px;
        background-color: #9b0858;
        pointer-events: auto;
    }
    input[type="range"]::-ms-thumb{
        appearance: none;
        height: 20px;
        width: 20px;
        background-color: #9b0858;
        border-radius: 50%;
        cursor: pointer;
        pointer-events: auto;
    }
    input[type="range"]:active::-webkit-slider-thumb{
background-color: #ffffff;
border:3px solid #9b0858;
    }
                        </style> -->
                        <!-- <input type="range" [(ngModel)]="selectedRange.min" [min]="prices1[0]" [max]="selectedRange.max" value="100" step="50" id="slider-1">
                        <input type="range" [(ngModel)]="selectedRange.max" [min]="selectedRange.min"  [max]="prices1[prices1.length - 1]" value="600" step="50" id="slider-2"> -->
                        <input class="slider1" type="range" [(ngModel)]="selectedRange.min" id="slider-1" [min]="prices1[0]" [max]="prices1[13]" value={{selectedRange.min}} step="50" (change)="scrollchange()">
                        <output style="margin-top: 9px; font-size: 13px;font-weight: 600; margin-bottom: 5px;">{{prices1[0]}}</output>
                        <input type="range" class="slider2" [(ngModel)]="selectedRange.max"  id="slider-2" [min]="prices1[0]"  [max]="prices1[13]" value={{selectedRange.max}} step="50" (change)="scrollchange()">
                         <output style="float: right;margin-top: 9px;font-size: 13px;font-weight: 600;margin-bottom: 5px;">{{prices1[13]}}</output>
                    </div>
                      
                      <div style="margin-top: 50px;">
                        <div style="display: flex;">
                            <div style="width: 50%;">
                            <span style="font-size: 14px;
                            margin-right: 5px;
                            font-weight: 600;">MIN:</span>
<span id="minOutput"  style="height: 25px;width: 40px;text-align: center;display: inline-block; background-color: #9b0858;color: white;">{{ selectedRange.min }} </span>
</div>
<div style="width: 50%;">
    <span style="font-size: 14px;
    margin-right: 5px;
    font-weight: 600;">MAX:</span>
<span id="maxOutput"  style="height: 25px;width: 40px;text-align: center;display: inline-block; background-color: #9b0858;color: white;">{{ selectedRange.max }} </span>
</div>  
                
                          </div>
                      </div>
                    <!-- <div class="card-body">
                        <ng-container *ngFor="let facet of prices" >
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:13px !important;font-weight: 500;color: #bf0a6d;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterPrice($event,facet) "/>
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div> -->
                        </div>
                    </div>
            </div>
    
        </div>
    </div>
    <!-- <div *ngIf="prices && configTitle === 'LushNGreen'">
        
        <div *ngIf="prices.length != 0" class="layerd-navigation">
            
            <div class="filter-collections-group">
                <div id="accordion">
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select" style="cursor: pointer;">Prices</a>
                            </div>
                </div>
                
                   
                    <div class="slider-track">
                        <style>
                            input[type="range"]{
                                -webkit-appearance: none;
                                -moz-appearance:none;
                                appearance: none;
                                width: 100%;
                                outline: none;
                                position: absolute;
                                margin: auto;
                                top: 0;
                                bottom: 0;
                                background-color: transparent;
                                pointer-events: none;
                            }
                            @media (min-width: 640px) {
                            .slider-track{
                            width: 16%;
    height: 5px;
    background-color: #d5d5d5;
    position: absolute;
    margin: auto;
    border-radius: 5px;
    margin-top: 15px;
                            }
                        }
                        @media (max-width: 640px) {
                            .slider-track{
                            width: 60%;
    height: 5px;
    background-color: #d5d5d5;
    position: absolute;
    margin: auto;
    border-radius: 5px;
    margin-top: 15px;
                            }
                        }
                            input[type="range"]::-webkit-slider-runnable-track{
                                -webkit-appearance:none;
                                height: 5px;
                            }
                            input[type="range"]::-moz-range-track{
                                -moz-appearance:none;
                                height: 5px;
                            }
    input[type="range"]::-ms-track{
        appearance: none;
        height: 5px;
    }
    input[type="range"]::-webkit-slider-thumb{
        -webkit-appearance:none;
        height: 20px;
        width: 20px;
        background-color: #a9c70b;
        cursor: pointer;
        border-radius: 10px;
        pointer-events: auto;
        margin-top: -9px;
        pointer-events: auto;
    }
    input[type="range"]::-moz-range-thumb{
        -webkit-appearance: none;
        height: 20px;
        width: 20px;
        background-color: #a9c70b;
        pointer-events: auto;
    }
    input[type="range"]::-ms-thumb{
        appearance: none;
        height: 20px;
        width: 20px;
        background-color: #a9c70b;
        border-radius: 50%;
        cursor: pointer;
        pointer-events: auto;
    }
    input[type="range"]:active::-webkit-slider-thumb{
background-color: #ffffff;
border:3px solid #a9c70b;
    }
                        </style>
                        <input class="slider1" type="range" [(ngModel)]="selectedRange.min" id="slider-1" [min]="prices2[0]" [max]="prices2[10]" value={{selectedRange1.min}} step="50" (change)="scrollchange1()">
                        <output style="margin-top: 9px; font-size: 13px;font-weight: 600; margin-bottom: 5px;">{{prices2[0]}}</output>
                        <input type="range" class="slider2" [(ngModel)]="selectedRange.max"  id="slider-2" [min]="prices2[0]"  [max]="prices2[10]" value={{selectedRange1.max}} step="50" (change)="scrollchange1()">
                         <output style="float: right;margin-top: 9px;font-size: 13px;font-weight: 600;margin-bottom: 5px;">{{prices2[10]}}</output>
                    </div>
                      
                      <div style="margin-top: 50px;">
                        <div style="display: flex;">
                            <div style="width: 50%;">
                            <span style="font-size: 14px;
                            margin-right: 5px;
                            font-weight: 600;">MIN:</span>
<span id="minOutput"  style="height: 25px;width: 40px;text-align: center;display: inline-block; background-color: #a9c70b;color: white;">{{ selectedRange1.min }} </span>
</div>
<div style="width: 50%;">
    <span style="font-size: 14px;
    margin-right: 5px;
    font-weight: 600;">MAX:</span>
<span id="maxOutput"  style="height: 25px;width: 40px;text-align: center;display: inline-block; background-color: #a9c70b;color: white;">{{ selectedRange1.max }} </span>
</div>  
                
                          </div>
                      </div>
            
                
            </div>
    
        </div>
    </div> -->
    <div *ngIf="prices && configTitle === 'ShubhCards'">
        <div *ngIf="prices.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true"
                        aria-controls="collapseSix" style="cursor: pointer;">Prices <i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseSix" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of prices" >
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterPrice($event,facet) "/>
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="finish && configTitle === 'ShubhCards'">
        <div *ngIf="finish.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true"
                        aria-controls="collapseFour" style="cursor: pointer;">Finish <i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseFour" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of finish">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterFinish($event,facet)" />
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="configTitle === 'LushNGreen'">
        <div class="layerd-navigation margintop-lush" style="border-top: 1px solid rgb(146, 146, 146);     padding-top: 20px !important;
        padding-bottom: 20px !important;" >
            <div class="filter-collections-group">
                <div id="accordion">
                    <div style="display: flex;">
                      <a class="sub-heading baby_filter_select" 
                         (click)="toggleCollapse()" data-toggle="collapse" data-target="#collapseTwelve" aria-expanded="true"
                         aria-controls="collapseTwelve"
                         style="cursor: pointer; text-transform: uppercase; width: 90%; font-family: Outfit, sans-serif !important; 
                         font-size: 14px !important; font-weight: 600; color: #575757 !important;">
                        Ideal Plants Location
                      </a>
                      <span class="baby-rotate">
                        <i [ngClass]="{'fa-plus': !isExpanded, 'fa-minus': isExpanded}" class="fa arrow-size baby_arrow"
                        data-toggle="collapse" data-target="#collapseTwelve" aria-expanded="true" (click)="toggleCollapse()"
                            aria-controls="collapseTwelve" style="height: 10px; font-size: 11px;"></i>
                      </span>
                    </div>
                  </div>
                <div id="collapseTwelve" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" #collapseTwelve>
                    <div class="card-body">
                        <ng-container>
 
                            <div class="collection-collapse-block">
     
                                <div class="pannel-title">
     
     
     
                                    <label class="checkbox-container" style="text-transform: uppercase;
                                            font-family: Outfit, sans-serif !important;
                                            font-size: 12px !important;
                                            font-weight: 500;
                                            color: #575757;" id="facet.name">
     
                                        <input type="checkbox" class="form-check-input" id='Exotic Plants' name="option1" style="margin-top: 6px;"
                                            value="something" [(ngModel)]="exoticPlants" (click)="appliedFilterAge($event,'Exotic Plants') " />
     
     
                                        &nbsp;Exotic Plants<span class="count"></span>
                                        <span class="checkmark"></span>
     
                                    </label>
     
     
                                </div>
     
                            </div>
                            <div class="collection-collapse-block">
     
                                <div class="pannel-title">
     
     
     
                                    <label class="checkbox-container" style="text-transform: uppercase;
                                            font-family: Outfit, sans-serif !important;
                                            font-size: 12px !important;
                                            font-weight: 500;
                                            color: #575757;" id="facet.name">
     
     
                                        <input type="checkbox" class="form-check-input" id='Indoor Plants' name="option1" style="margin-top: 6px;"
                                            value="something" [(ngModel)]="indoorPlants" (click)="appliedFilterAge($event,'Indoor Plants') " />
     
     
                                        &nbsp;Indoor Plants<span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
     
     
                                </div>
     
                            </div>
                            <div class="collection-collapse-block">
     
                                <div class="pannel-title">
     
     
     
                                    <label class="checkbox-container" style="text-transform: uppercase;
                                            font-family: Outfit, sans-serif !important;
                                            font-size: 12px !important;
                                            font-weight: 500;
                                            color: #575757;" id="facet.name">
     
     
                                        <input type="checkbox" class="form-check-input" id='Miniature Plants' name="option1" style="margin-top: 6px;"
                                            value="something" [(ngModel)]="miniaturePlants" (click)="appliedFilterAge($event,'Miniature Plants') " />
     
     
                                        &nbsp;Miniature Plants<span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
     
     
                                </div>
     
                            </div>
                            <div class="collection-collapse-block">
     
                                <div class="pannel-title">
     
     
     
                                    <label class="checkbox-container" style="text-transform: uppercase;
                                            font-family: Outfit, sans-serif !important;
                                            font-size: 12px !important;
                                            font-weight: 500;
                                            color: #575757;" id="facet.name">
     
     
                                        <input type="checkbox" class="form-check-input" id='Outdoor Plants' name="option1" style="margin-top: 6px;"
                                            value="something" [(ngModel)]="outdoorPlants" (click)="appliedFilterAge($event,'Outdoor Plants') " />
     
     
                                        &nbsp;Outdoor Plants<span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
     
     
                                </div>
     
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="type && configTitle === 'LushNGreen'">
        <div *ngIf="type.length != 0" class="layerd-navigation" style="border-top: 1px solid rgb(146, 146, 146);    padding-top: 20px !important;
        padding-bottom: 20px !important;">
            <div class="filter-collections-group" >
                <div id="accordion">
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseTen" aria-expanded="myboolean"
                            aria-controls="collapseTen" style="cursor: pointer;text-transform: uppercase;width: 90%;
                            font-family: Outfit, sans-serif !important;
                            font-size: 14px !important;
                            font-weight: 600;
                            color: #575757 !important;">Water Schedule</a>
                            <span class="baby-rotate">
                            <i class="fa fa-plus arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseTen" aria-expanded="myboolean"
                            aria-controls="collapseTen" style="height: 10px;font-size: 11px;" ></i></span>
                            </div>
                </div>
                <div id="collapseTen" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" #collapseTen>
                    <div class="card-body">
                        <ng-container *ngFor="let facet of type" >
    
                            <div class="collection-collapse-block"  *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase;
                                        font-family: Outfit, sans-serif !important;
                                        font-size: 12px !important;
                                        font-weight: 500;
                                        color: #575757;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterType($event,facet) "/>
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="material && configTitle === 'LushNGreen'">
        <div *ngIf="material.length != 0" class="layerd-navigation" style="border-top: 1px solid rgb(146, 146, 146);    padding-top: 20px !important;
        padding-bottom: 20px !important;">
            <div class="filter-collections-group">
                <div id="accordion">
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="myboolean"
                            aria-controls="collapseEleven" style="cursor: pointer;text-transform: uppercase;width: 90%;
                            font-family: Outfit, sans-serif !important;
                            font-size: 14px !important;
                            font-weight: 600;
                            color: #575757 !important;">Pot Size</a>
                            <span class="baby-rotate">
                            <i class="fa fa-plus arrow-size baby_arrow" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="myboolean"
                            aria-controls="collapseEleven" style="height: 10px;font-size: 11px;" ></i></span>
                            </div>
                </div>
                <div id="collapseEleven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" #collapseEleven>
                    <div class="card-body">
                        <ng-container *ngFor="let facet of material" >
    
                            <div class="collection-collapse-block"  *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase;
                                        font-family: Outfit, sans-serif !important;
                                        font-size: 12px !important;
                                        font-weight: 500;
                                        color: #575757;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterMaterial($event,facet) "/>
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="color && (configTitle === 'BestGifts')">
        <div *ngIf="color.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseNine" aria-expanded="true"
                        aria-controls="collapseNine" style="cursor: pointer;">Color<i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseNine" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of color">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterColor($event,facet)" />
                                        <!-- <input type="checkbox"  (click)="appliedFilterColor($event,facet)"/> -->
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="type && (configTitle === 'Beaubelle' || configTitle === 'BestGifts')">
        <div *ngIf="type.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseTen" aria-expanded="true"
                        aria-controls="collapseTen" style="cursor: pointer;">Type<i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseTen" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of type">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterType($event,facet)" />
                                        <!-- <input type="checkbox"  (click)="appliedFilterColor($event,facet)"/> -->
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>
    <div *ngIf="material && (configTitle === 'Beaubelle' || configTitle === 'BestGifts')">
        <div *ngIf="material.length != 0" class="layerd-navigation">
            <div class="filter-collections-group">
                <div id="accordion">
                    <a class="sub-heading" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="true"
                        aria-controls="collapseEleven" style="cursor: pointer;">Material<i
                        class="fa fa-angle-down arrow-size"></i> </a>
                       
                </div>
                <div id="collapseEleven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <ng-container *ngFor="let facet of material">
    
                            <div class="collection-collapse-block" [class.open]="collapse" *ngIf="facet">
    
                                <div class="pannel-title">
    
    
    
                                    <label class="checkbox-container"
                                        style="text-transform: uppercase; font-size:12px !important;">
    
                                        <input type="checkbox" [id]='facet.name' (click)="appliedFilterMaterial($event,facet)" />
                                        <!-- <input type="checkbox"  (click)="appliedFilterColor($event,facet)"/> -->
    
                                        &nbsp;{{ facet.name }} <span class="count"></span>
                                        <span class="checkmark"></span>
                                    </label>
    
    
                                </div>
    
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
    
        </div>
    </div>

    <button id="collapseFilter" class="mobile-only filter-button" type="button" data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
    aria-controls="collapseFilter">Apply Filter</button>

</div>

    <div class="layerd-navigation" *ngIf="configTitle !== 'Aiema' && configTitle !== 'KatbookStore' && configTitle !== 'Schift Cosmetics' && configTitle !== 'Accel' &&configTitle !== 'ShubhCards' &&configTitle !== 'Cle' &&configTitle !== 'Carience' && configTitle !== 'SpecialWires' &&configTitle !== 'Vimpro'&&configTitle !== 'Deera' && configTitle!=='Babys Pride'  &&configTitle !== 'Beaubelle'  &&configTitle !== 'BombayHardware' &&configTitle !== 'BestGifts'&&configTitle !== 'Kubendran'&& configTitle !== 'Karupattiraja' && configTitle!=='LushNGreen' && configTitle!=='SriSenbaga'">
        <div class="filter-collections-group">
            <div class="collection-collapse-block border-0">
                <h5 class="collapse-block-title sub-heading">Availability</h5>
                <div class="collection-collapse-block-content">
                    <div class="collection-brand-filter">
                        <div>
                            <label class="checkbox-container" style="text-transform: uppercase; font-size:12px !important;">
    
                                <input type="checkbox" [(ngModel)]="values1" id='outOfStock'
                                    (change)="onChange($event,'Include Out of Stock')" [value]="" />
                                &nbsp;Include Out of Stock
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="collection-collapse-block border-0">
                            <h5 class="collapse-block-title sub-heading" style="margin-left:-30px">New Arrivals</h5>
                            <div>
                                <label class="checkbox-container" style="font-size: 14px !important;">
                                    <input type="checkbox" [(ngModel)]="values2" id='day90'
                                        (change)="onChange($event,'Last 90 days')"
                                        (click)="changeCheckecd($event,'Last 90 days')" [value]="" checked />
                                    &nbsp;Last 90 days
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="mt-2">
                                <label class="checkbox-container" style="font-size: 14px !important;">
    
                                    <input (change)="onChange($event,'Last 30 days')"
                                        (click)="changeCheckecd($event,'Last 30 days')" type="checkbox"
                                        [(ngModel)]="values3" id='day30' [value]="" />
                                    &nbsp;Last 30 days
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 
    <!-- <div class="layerd-navigation" >
            <div class="filter-collections-group">
                <div class="collection-collapse-block border-0" >
                    <h5 class="collapse-block-title sub-heading">Price</h5>
    
                    <input type="range" min="0" max="10000" />
                </div>
            </div>
        </div> -->
</div>




<div *ngIf="configTitle === 'Aiema'">
    <div *ngIf="categoriesList.length>0" class="layerd-navigation">
        <div class="filter-collections-group desktop-filter">
            <hr>
            <div id="accordion" class="" >
                <h5 class="mb-0">
                    <a id="mob-filter" style="text-transform: capitalize;color: rgb(63, 63, 63) !important; font-size: 17px;font-weight: bold;font-family: 'proxima-regular','sans-serif'!important;">Categories </a>
                    <span class="fa fa-rotate-left" style="float:right; cursor: pointer;" (click)="clearAll()"></span> 
                </h5>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body" style="padding-left: 0px !important;padding-right: 0px !important;font-family: 'proxima-regular','sans-serif'!important;">
                    <ng-container>
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 6px;">
                            <div class="wrapper">
                                <li>
                                    <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list" style="font-size: 13.5px !important;
                                        line-height: normal !important;
                                        color: #333333 !important;
                                        font-family: 'proxima-regular','sans-serif'!important;" (click)="checkedevt1(category.name, category.name)">
                                        {{category.name | titlecase | productDetailsPipe: category.name}}
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="filter-collections-group mobile-filter">
            <div id="accordion">
                <div id="accordion">
                    <h5 class="mb-0">
                        <a id="mob-filter" class="sub-heading" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                            aria-controls="collapseOne" style="float:right;position:absolute;top:0px;left:60%;cursor: pointer;text-transform: capitalize;color: rgb(63, 63, 63) !important; font-size: 22px;font-weight: bold;font-family: 'proxima-regular','sans-serif'!important;margin-top:10px">
                            Categories <i class="fa fa-angle-down pl-2"></i> 
                        </a>
                    </h5>
                </div>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" style="transition: all 0.5s ease-out;">
                <div class="card-body mob-categories">
                    <div data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                    aria-controls="collapseOne" style="font-family: 'proxima-regular','sans-serif'!important; font-weight: 1000; float:right"> <i class="fa fa-angle-left pl-2" (click)="clearAll()"></i> &nbsp;Back</div>
                    <ng-container>
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 6px; line-height:1.3rem">
                            <hr style="margin:0.7rem; background-color:white !important;border:none !important">
                            <div class="wrapper">
                                <li><a [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list-mob-aiema" style="font-family: 'proxima-regular','sans-serif'!important;color:#D57C30!important;font-size: 16px; font-weight:100"
                                        (click)="checkedevt1(category.name, category.name)" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                        aria-controls="collapseOne">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}<span *ngIf="category.subcategories">  </span>
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container>
                    <!-- <div class="touch-out" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                    aria-controls="collapseOne" >
                    </div> -->
                </div>
            </div>            
        </div>
    </div>
    <div class="pb-6"></div>
</div>
<div *ngIf="configTitle === 'Accel'">
    <div *ngIf="categoriesList.length>0" class="layerd-navigation">
        <div class="filter-collections-group desktop-filter">
           
            <div id="accordion" class="" >
                <h5 class="mb-0 cate_filter" style="display: flex;justify-content: center;">
                   
                    <i class="fa fa-diamond" aria-hidden="true" style="color: #ff5c00;"></i>
                    <a id="mob-filter" style="text-transform: capitalize;color: rgb(63, 63, 63) !important; font-size: 17px;font-weight: bold;font-family: 'proxima-regular','sans-serif'!important;margin-left: 5%;">COURSES</a>
                    
                    
                    <!-- <span class="fa fa-rotate-left" style="float:right; cursor: pointer;" (click)="clearAll()"></span>  -->
                </h5>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" style="margin-top: -7.2%;">
                <div class="card-body" style="padding-left: 0px !important;padding-right: 0px !important;font-family: 'proxima-regular','sans-serif'!important;margin-left: -10%;">
                    <ng-container>
                        <div class="sublist-font-accel" *ngFor="let category of categoriesList; index as i" style="width: 82%;margin-left: 9%;" tabindex="0"
                           >
                            <div class="wrapper" >
                                <li>
                                    <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list-accel" style="font-size: 17.5px !important;
                                        line-height: normal !important;
                                       
                                        font-family: 'proxima-regular','sans-serif'!important;" (click)="checkedevt1(category.name, category.name)">
                                        {{category.name | titlecase | productDetailsPipe: category.name}}
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="filter-collections-group mobile-filter mobile-only">
            <div id="accordion">
                <div id="accordion">
                    <h5 class="mb-0">
                        <a id="mob-filter" class="sub-heading" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                            aria-controls="collapseOne" style="float:right;position:absolute;top:0px;left:60%;cursor: pointer;text-transform: capitalize;color: rgb(63, 63, 63) !important; font-size: 22px;font-weight: bold;font-family: 'proxima-regular','sans-serif'!important;margin-top:10px">
                            Categories <i class="fa fa-angle-down pl-2"></i> 
                        </a>
                    </h5>
                </div>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" style="transition: all 0.5s ease-out;">
                <div class="card-body mob-categories">
                    <div data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                    aria-controls="collapseOne" style="font-family: 'proxima-regular','sans-serif'!important; font-weight: 1000; float:right"> <i class="fa fa-angle-left pl-2" (click)="clearAll()"></i> &nbsp;Back</div>
                    <ng-container>
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 6px; line-height:1.3rem">
                            <hr style="margin:0.7rem; background-color:white !important;border:none !important">
                            <div class="wrapper">
                                <li><a [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list-mob-aiema" style="font-family: 'proxima-regular','sans-serif'!important;color:#D57C30!important;font-size: 16px; font-weight:100"
                                        (click)="checkedevt1(category.name, category.name)" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                        aria-controls="collapseOne">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}<span *ngIf="category.subcategories">  </span>
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container>
                    <!-- <div class="touch-out" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                    aria-controls="collapseOne" >
                    </div> -->
                </div>
            </div>            
        </div>
    </div>
    <div class="pb-6"></div>
</div>

<div *ngIf="configTitle === 'Cle' ">
    <div *ngIf="categoriesList.length>0" class="layerd-navigation">
        <div class="filter-collections-group desktop-filter">
            <hr>
            <div id="accordion" class="" >
                <h5 class="mb-0">
                    <a id="mob-filter" style="text-transform: capitalize;color: rgb(63, 63, 63) !important; font-size: 17px;font-weight: bold;font-family: 'proxima-regular','sans-serif'!important;">Categories </a>
                    <span class="fa fa-rotate-left" style="float:right; cursor: pointer;" (click)="clearBest()"></span> 
                </h5>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                <div class="card-body" style="padding-left: 0px !important;padding-right: 0px !important;font-family: 'proxima-regular','sans-serif'!important;">
                    <ng-container>
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 6px;">
                            <div class="wrapper">
                                <li>
                                    <a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list" style="font-size: 13.5px !important;
                                        line-height: normal !important;
                                        color: #333333 !important;
                                        font-family: 'proxima-regular','sans-serif'!important;" (click)="checkedevt1(category.name, category.name)">
                                        {{category.name | titlecase | productDetailsPipe: category.name}}
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="filter-collections-group mobile-filter">
            <div id="accordion">
                <div id="accordion">
                    <h5 class="mb-0">
                        <a id="mob-filter" class="sub-heading" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                            aria-controls="collapseOne" style="float:right;position:absolute;top:0px;left:60%;cursor: pointer;text-transform: capitalize;color: rgb(63, 63, 63) !important; font-size: 22px;font-weight: bold;font-family: 'proxima-regular','sans-serif'!important;margin-top:10px">
                            Categories <i class="fa fa-angle-down pl-2"></i> 
                        </a>
                    </h5>
                </div>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" style="transition: all 0.5s ease-out;">
                <div class="card-body mob-categories">
                    <div data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                    aria-controls="collapseOne" style="font-family: 'proxima-regular','sans-serif'!important; font-weight: 1000; float:right"> <i class="fa fa-angle-left pl-2" (click)="clearAll()"></i> &nbsp;Back</div>
                    <ng-container>
                        <div class="sublist-font" *ngFor="let category of categoriesList; index as i"
                            style="margin-bottom: 6px; line-height:1.3rem">
                            <hr style="margin:0.7rem; background-color:white !important;border:none !important">
                            <div class="wrapper"> 
                                <li><a [id]='category.name' [class.active]="active === category.name || categoryName===category.name"
                                        class="sub-list-mob-aiema" style="font-family: 'proxima-regular','sans-serif'!important;color:#333333!important;font-size: 16px; font-weight:100"
                                        (click)="checkedevt1(category.name, category.name)" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                        aria-controls="collapseOne">{{category.name | titlecase |
                                        productDetailsPipe: category.name}}<span *ngIf="category.subcategories">  </span>
                                    </a>
                                </li>
                            </div>
                        </div>
                    </ng-container>
                    <!-- <div class="touch-out" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                    aria-controls="collapseOne" >
                    </div> -->
                </div>
            </div>            
        </div>
    </div>
    <div class="pb-6"></div>
</div>
<div *ngIf="configTitle === 'KatbookStore' " class="desktop-only">
    <div class="container mt-3 border"  *ngIf="categoriesList.length!=0">
        <div>
            <!-- <h4 style="font-size:18px !important">Institution</h4> -->
            <div id="accordion" style="display: flex;justify-content: space-between;">
                <a class="sub-heading "  data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true"
                    aria-controls="collapseTwo" style="cursor: pointer;">Institution</a>
                    <i class="fa fa-angle-down arrow-size" style="margin-top: 3%"></i>
                   
            </div>
                <!-- <i class="icon-collapse"  data-toggle="collapse" data-target="#collapsibleDiv" aria-expanded="true" aria-controls="collapsibleDiv" style="color: #23a6f0;font-size: 20px;"></i> -->
            
        </div>
        
        <form action="/action_page.php" id="collapseTwo" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" >
            <div class="form-check" style="line-height: 2.5rem" >
                <input type="checkbox" class="form-check-input kat_input" id="checkinst" name="option1" value="something" checked (click)="appliedAllCFilter($event)">
                <label class="form-check-label" for="check1" style="text-transform: capitalize;font-size: 14px;">All</label>
              </div>
                <ng-container *ngFor="let facet of categoriesList" >
    
                    <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">

                            <label class="sub-list_kat"
                                style="text-transform: uppercase;" id="facet.name">

                                <input type="checkbox" style="padding:10px" class="form-check-input kat_input" [id]='facet.name' name="option1" value="something" (click)="appliedFilterCategories($event,facet)"/>

                                &nbsp;{{ facet.name }} <span class="count"></span>
                                <span class="checkmark"></span>
                            </label>

                    </div>
                </ng-container>
                
          <!-- </div> -->
         
        </form>
       
      </div>
      <div class="container mt-3 border" *ngIf="affiliation.length!=0">
        <div >
        <!-- <h4 style="font-size:18px !important" >Affiliation</h4> --> 
        <div id="accordion" style="display: flex;justify-content: space-between;">
                <a class="sub-heading "  data-toggle="collapse" data-target="#collapseThree" aria-expanded="true"
                aria-controls="collapseThree" style="cursor: pointer;">Affiliation</a>
                <i
                class="fa fa-angle-down arrow-size" style="margin-top: 3%"></i>
               
        </div>
        <!-- <i class="icon-collapse"  data-toggle="collapse" data-target="#collapsibleDiv1" aria-expanded="false" aria-controls="collapsibleDiv1" style="color: #23a6f0;font-size: 20px;"></i></div> -->
    </div>
        <form action="/action_page.php" id="collapseThree" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="form-check" style="line-height: 2.5rem" >
                <input type="checkbox" class="form-check-input kat_input" id="checkaff" name="option1" value="something" (click)="appliedAllAffFilter($event)" checked>
                <label class="form-check-label" value="all" for="checkaff" style="text-transform: capitalize;font-size: 14px;">All</label>
              </div>
          <!-- <div class="form-check"  *ngFor="let facet of affiliation; index as i" style="line-height: 2.5rem">
            <input type="checkbox" class="form-check-input" id="check1" name="option1" value="something" >
            <label class="form-check-label"  for="check1" style="color: #616161;text-transform: capitalize;" >{{facet.name}}</label>
          </div> -->
          <ng-container *ngFor="let facet of affiliation" >
    
            <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">

                    <label class="sub-list_kat"
                        style="text-transform: uppercase;" id="facet.name">

                        <input type="checkbox" style="padding:10px" class="form-check-input kat_input" [id]='facet.name' name="option1" value="something" (click)="appliedFilterAffiliation($event,facet)"/>

                        &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                        <span class="checkmark"></span>
                    </label>

            </div>
        </ng-container>
         
        </form>
      </div>
      <div class="container mt-3 border" *ngIf="filters.length!=0">
        
        <div >
            
        <!-- <h4  style="white-space: nowrap; font-size:18px !important">Medium of Instruction
        </h4> -->
        <div id="accordion" style="display: flex;justify-content: space-between;">
            <a class="sub-heading "  data-toggle="collapse" data-target="#collapsefour" aria-expanded="true"
            aria-controls="collapsefour" style="cursor: pointer;">Medium of Instruction</a>
            <i
            class="fa fa-angle-down arrow-size" style="margin-top: 3%"></i>
           
    </div>
        <!-- <i class="icon-collapse"  data-toggle="collapse" data-target="#collapsibleDiv2" aria-expanded="false" aria-controls="collapsibleDiv2" style="color: #23a6f0;font-size: 20px;"></i> -->
    </div>

        <form action="/action_page.php" id="collapsefour" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="form-check" style="line-height: 2.5rem" >
                <input type="checkbox" class="form-check-input kat_input" id="checkmedium" name="option1" value="something" checked (click)="appliedAllBFilter($event)">
                <label class="form-check-label" for="check1" style="text-transform: capitalize;font-size: 14px;">All</label>
              </div>
          <!-- <div class="form-check"  *ngFor="let facet of filters; index as i" style="line-height: 2.5rem">
            <input type="checkbox" class="form-check-input" id="facet.name" name="option1" value="something" >
            <label class="form-check-label" [id]="facet.name" for="check1"  style="color: #616161;text-transform: capitalize;" (click)="appliedFilter($event,facet)">{{facet.name}}</label>
          </div> -->
          <ng-container *ngFor="let facet of filters" >
    
            <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">

                    <label class="sub-list_kat"
                        style="text-transform: uppercase;" id="facet.name">

                        <input type="checkbox" style="padding:10px" class="form-check-input kat_input" [id]='facet.name' name="option1" value="something" (click)="appliedFilterKat($event,facet)"/>

                        &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                        <span class="checkmark"></span>
                    </label>

            </div>
        </ng-container>
         
        </form>
      </div>
      <div class="container mt-3 border" *ngIf="standard.length!=0">
        <div >
        <!-- <h4 style="font-size:18px !important">Standard</h4> -->
        <div id="accordion" style="display: flex;justify-content: space-between;">
            <a class="sub-heading "  data-toggle="collapse" data-target="#collapsefive" aria-expanded="true"
            aria-controls="collapsefive" style="cursor: pointer;">Standard</a>
            <i
            class="fa fa-angle-down arrow-size" style="margin-top: 3%"></i>
           
    </div>
        <!-- <i class="icon-collapse"  data-toggle="collapse" data-target="#collapsibleDiv3" aria-expanded="false" aria-controls="collapsibleDiv3" style="color: #23a6f0;font-size: 20px;"></i> -->
    </div>

        <form action="/action_page.php" id="collapsefive" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" >
            <div class="form-check" style="line-height: 2.5rem" >
                <input type="checkbox" class="form-check-input kat_input" id="checkstan" name="option1" value="something" checked (click)="appliedAllStanFilter($event)">
                <label class="form-check-label" for="checkstan" style="text-transform: capitalize;font-size: 14px;">All</label>
              </div>
              <ng-container *ngFor="let facet of standard" >
    
                <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
    
                        <label class="sub-list_kat"
                            style="text-transform: uppercase;" id="facet.name">
    
                            <input type="checkbox" style="padding:10px" class="form-check-input kat_input" [id]='facet.name' name="option1" value="something" (click)="appliedFilterStandard($event,facet)"/>
    
                            &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                            <span class="checkmark"></span>
                        </label>
    
                </div>
            </ng-container>
          
         
        </form>
      </div>
      <div class="container mt-3 border" *ngIf="subject.length!=0">
        <div >
            <div id="accordion" style="display: flex;justify-content: space-between;">
                <a class="sub-heading "  data-toggle="collapse" data-target="#collapsesix" aria-expanded="true"
                aria-controls="collapsesix" style="cursor: pointer;">Subject</a>
                <i
                class="fa fa-angle-down arrow-size" style="margin-top: 3%"></i>
               
        </div>
        <!-- <h4 style="font-size:18px !important">Subject</h4> -->
        <!-- <i class="icon-collapse"  data-toggle="collapse" data-target="#collapsibleDiv4" aria-expanded="false" aria-controls="collapsibleDiv4" style="color: #23a6f0;font-size: 20px;"></i> -->
    </div>

        <form action="/action_page.php" id="collapsesix" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="form-check" style="line-height: 2.5rem" >
                <input type="checkbox" class="form-check-input kat_input" id="checksubj" name="option1" value="something" checked (click)="appliedAllSubjFilter($event)">
                <label class="form-check-label" for="checksubj" style="text-transform: capitalize;font-size: 14px;">All</label>
              </div>
              <ng-container *ngFor="let facet of subject" >
    
                <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
    
                        <label class="sub-list_kat"
                            style="text-transform: uppercase;" id="facet.name">
    
                            <input type="checkbox" style="padding:10px" class="form-check-input kat_input" [id]='facet.name' name="option1" value="something" (click)="appliedFilterSubject($event,facet)"/>
    
                            &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                            <span class="checkmark"></span>
                        </label>
    
                </div>
            </ng-container>
          
         
        </form>
      </div>
      <div class="container mt-3 border" *ngIf="year.length!=0">
        <div >
        <!-- <h5  style="font-weight: 900;">Year</h5> -->
        <div id="accordion" style="display: flex;justify-content: space-between;">
            <a class="sub-heading "  data-toggle="collapse" data-target="#collapseseven" aria-expanded="true"
            aria-controls="collapseseven" style="cursor: pointer;">Year</a>
            <i
            class="fa fa-angle-down arrow-size" style="margin-top: 3%"></i>
           
    </div>
        <!-- <i class="icon-collapse"  data-toggle="collapse" data-target="#collapsibleDiv5" aria-expanded="false" aria-controls="collapsibleDiv5" style="color: #23a6f0;font-size: 20px;"></i> -->
    </div>

        <form id="collapseseven" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
            <div class="form-check" style="line-height: 2.5rem" >
                <input type="checkbox" class="form-check-input kat_input" id="checkyear" name="option1" value="something" checked (click)="appliedAllYeaFilter($event)">
                <label class="form-check-label" for="checkyear" style="text-transform: capitalize;font-size: 14px;">All</label>
              </div>
              <ng-container *ngFor="let facet of year" >
    
                <div class="form-check collection-collapse-block"  *ngIf="facet" style="line-height: 2.5rem;margin-left: 6px !important;">
    
                        <label class="sub-list_kat"
                            style="text-transform: uppercase;" id="facet.name">
    
                            <input type="checkbox" style="padding:10px" class="form-check-input kat_input" [id]='facet.name' name="option1" value="something" (click)="appliedFilterYear($event,facet)"/>
    
                            &nbsp;&nbsp;&nbsp;{{ facet.name }} <span class="count"></span>
                            <span class="checkmark"></span>
                        </label>
    
                </div>
            </ng-container>
          
         
        </form>
      </div>
      <div class="container mt-3 border">
        
       
            
            <div class="filter-collections-group">
                <div id="accordion" style="display: flex;justify-content: space-between;">
                    <!-- <a class="sub-heading" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true"
                        aria-controls="collapseSix" style="cursor: pointer;">Prices <i
                        class="fa fa-angle-down arrow-size"></i> </a> -->
                        <div style="display: flex;">
                            <a class="sub-heading baby_filter_select" style="cursor: pointer;">Prices</a>
                            </div>
                </div>
                
                    <!-- <ng5-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options"></ng5-slider> -->
                   
                    <div class="slider-track">
                        <style>
                           
                        </style>
                        <!-- <input type="range" [(ngModel)]="selectedRange.min" [min]="prices1[0]" [max]="selectedRange.max" value="100" step="50" id="slider-1">
                        <input type="range" [(ngModel)]="selectedRange.max" [min]="selectedRange.min"  [max]="prices1[prices1.length - 1]" value="600" step="50" id="slider-2"> -->
                        <input class="slider1" type="range" [(ngModel)]="selectedRange1.min" id="slider-1" [min]="prices2[0]" [max]="prices2[10]" value={{selectedRange1.min}} step="100" (change)="scrollchange1()">
                        <output style="margin-top: 9px; font-size: 13px;font-weight: 600; margin-bottom: 5px;">{{prices2[0]}}</output>
                        <input type="range" class="slider2" [(ngModel)]="selectedRange1.max"  id="slider-2" [min]="prices2[0]"  [max]="prices2[10]" value={{selectedRange1.max}} step="100" (change)="scrollchange1()">
                         <output style="float: right;margin-top: 9px;font-size: 13px;font-weight: 600;margin-bottom: 5px;">{{prices2[10]}}</output>
                    </div>
                      
                      <div style="margin-top: 50px;">
                        <div style="display: flex;justify-content: space-around;">
                            <div>
                            <!-- <span style="font-size: 14px;
                            margin-right: 5px;
                            font-weight: 600;">MIN:</span> -->
<span id="minOutput"  style="height: 50px;width: 100px;text-align: center;display: inline-block; background-color: #f9f9f9;    border: 2px solid #e9e9e9;color: black;border-radius: 10px;"><h5  style="margin-top: 15%;">{{ selectedRange1.min }} </h5></span>
</div>
<div >
    <!-- <span style="font-size: 14px;
    margin-right: 5px;
    font-weight: 600;">MAX:</span> -->
<span id="maxOutput"  style="height: 50px;width: 100px;text-align: center;display: inline-block; background-color: #f9f9f9;color: black;border-radius: 10px;    border: 2px solid #e9e9e9"> <h5  style="margin-top: 15%;">{{ selectedRange1.max }}</h5> </span>
</div>  
                
                          </div>
                      </div>
                  
                
            </div>
    
        
    </div>

</div > 
